import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebaseConnection'; 


export async function getPermissions(userId) {
  try {
    // Recuperar o documento do usuário para obter o cargo
    const userDocRef = doc(db, 'User', userId);
    const userDoc = await getDoc(userDocRef);

    if (!userDoc.exists()) {
      throw new Error('Usuário não encontrado');
    }

    const userData = userDoc.data();
    const userCargoId = userData.cargo;  // Pegue o ID do cargo do usuário

    // Buscar o cargo no Firestore para obter as permissões
    const cargoDocRef = doc(db, 'Cargo', userCargoId);
    const cargoDoc = await getDoc(cargoDocRef);

    if (!cargoDoc.exists()) {
      throw new Error('Cargo não encontrado');
    }

    const cargoData = cargoDoc.data();
    const permissions = cargoData.permissoes || [];  // As permissões do cargo

    return permissions;
  } catch (error) {
    console.error('Erro ao obter permissões:', error);
    throw error;
  }
}


